import React, { memo, useState, useCallback, useEffect, useMemo } from 'react'
import { Modal, Form, Button } from 'antd'
import { CalculatorOutlined } from '@ant-design/icons'
import { FormikProvider, useFormik } from 'formik'
import { TextField } from '@shared/modules/form/fields/text'

type DiscountCalculatorProps = {
    servicePrice: number
    onApply: (discountAmount: number) => void
    disabled?: boolean
}

export const DiscountCalculator = memo<DiscountCalculatorProps>(({ servicePrice, onApply, disabled = false }) => {
    const [visible, setVisible] = useState(false)
    const formik = useFormik({
        initialValues: {
            percentage: '',
            calculatedDiscount: '0',
        },
        onSubmit: () => undefined,
    })

    const parsedPercentage = useMemo(() => parseFloat(formik.values.percentage || ''), [formik.values.percentage])

    const calculatedDiscount = useMemo(() => {
        if (!isNaN(parsedPercentage)) {
            const discount = (servicePrice * parsedPercentage) / 100
            return Number(discount.toFixed(2))
        }

        return 0
    }, [parsedPercentage, servicePrice])

    useEffect(() => {
        formik.setFieldValue('calculatedDiscount', calculatedDiscount.toString(), false)
    }, [calculatedDiscount, formik])

    const handleApply = useCallback(() => {
        onApply(calculatedDiscount)
        formik.resetForm()
        setVisible(false)
    }, [calculatedDiscount, formik, onApply])

    const handleCancel = useCallback(() => {
        formik.resetForm()
        setVisible(false)
    }, [formik])

    return (
        <>
            <Button
                type='text'
                disabled={disabled}
                icon={<CalculatorOutlined />}
                onClick={() => setVisible(true)}
            />
            <Modal
                title='Endirim Kalkulyatoru'
                open={visible}
                onCancel={handleCancel}
                footer={[
                    <Button key='cancel' onClick={handleCancel}>
                        Ləğv et
                    </Button>,
                    <Button key='apply' type='primary' onClick={handleApply}>
                        Tətbiq et
                    </Button>,
                ]}
                width={400}
            >
                <FormikProvider value={formik}>
                    <Form layout='vertical'>
                        <TextField
                            name='percentage'
                            format='integer'
                            item={{ label: 'Faizi' }}
                            input={{
                                addonAfter: '%',
                                placeholder: 'Faiz daxil edin',
                            }}
                        />
                        <TextField
                            name='calculatedDiscount'
                            format='decimal'
                            item={{ label: 'Hesablanmış Endirim məbləği' }}
                            input={{ disabled: true, suffix: '₼' }}
                        />
                    </Form>
                </FormikProvider>
            </Modal>
        </>
    )
})


DiscountCalculator.displayName = 'DiscountCalculator'